import Http from "./http";

export const addNotificationsAPI = (data, options) => {
    return Http.post("admin/createNotification", data, options);
};
